import { render } from "./AnimalsNavi.vue?vue&type=template&id=39331ae2&scoped=true"
import script from "./AnimalsNavi.vue?vue&type=script&lang=js"
export * from "./AnimalsNavi.vue?vue&type=script&lang=js"

import "./AnimalsNavi.vue?vue&type=style&index=0&id=39331ae2&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39331ae2"]])

export default __exports__